import React from 'react';
import PropTypes from 'prop-types';

const ChatEmpty = props => {
  const { trans } = props;
  return (
    <div className="chat-detail">
      <div className="chat-detail-head">
        <span style={{ marginLeft: '20px' }}>{trans['No Conversation Selected']}</span>
      </div>
    </div>
  );
};

ChatEmpty.propTypes = {
  trans: PropTypes.shape().isRequired,
};

export default ChatEmpty;
